export default [
    // {
    //     num: 0,
    //     label: {
    //         en: 'Deleted',
    //         et: 'Kustutatud',
    //         ru: 'Удалено',
    //     },
    //     color: 'red'
    // },
    {
        num: 1,
        label: {
            en: 'Active',
            et: 'Aktiivne',
            ru: 'Активный',
            lv: "Aktīvs",
            lt: "Aktyvus",
            fi: "Aktiivinen",
        },
        color: 'green'
    },
    {
        num: 0,
        label: {
            en: 'Not Active',
            et: 'Pole aktiivne',
            ru: 'Не активный',
            lv: "Neaktīvs",
            lt: "Neaktyvus",
            fi: "Ei aktiivinen",
        },
        color: 'red'
    },
]